import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as faHeartO } from "@fortawesome/free-regular-svg-icons";
import { faCartArrowDown, faCartPlus, faCartShopping, faHeart } from "@fortawesome/free-solid-svg-icons";
import { ellipsizetext } from "../../_helpers/ellipsize";
import { formatImageUrl } from "../../_helpers/route-image";

export const ProductCard = ({ item, onClick, onCartAdd, onLike, cart, wishList }) => {
    const computeDiscount = (price, percentage) => {
        return parseInt(price) - price * parseFloat(percentage);
    }

    const isNew = (item) => {
        const twoWeeks = 14 * 24 * 60 * 60 * 1000;
        const today = new Date();
        const thatDay = new Date(item.newArrival);

        return today - thatDay < twoWeeks;
    }

    const { original_cost, discount } = item?.pricing;

    return (
        <div>
            <button
                className="wish-button"
                onClick={onLike}
            >
                <FontAwesomeIcon
                    icon={wishList?.some((elem) => elem?._id === item?._id) ? faHeart : faHeartO}
                />
            </button>
            <button
                className="cart-add-button"
                onClick={onCartAdd}
            >
                <FontAwesomeIcon
                    icon={faCartShopping}
                />
            </button>
            {isNew(item) && <button className="new-sticker">New Arrival</button>}
            <button
                className="item-container"
                key={item._id}
                onClick={onClick}
            >

                
                <img 
                    src={formatImageUrl(item.images[0])} 
                    alt="" 
                    className="card-image" 
                />
                <span className="item-info">
                    <span className="item-brand">{item.brand}</span>
                    <span className="item-name">{ellipsizetext(item.designation)}</span>
                    <span 
                        className="prod-condition"
                        style={{backgroundColor: item?.condition === "New" ? "green" : "orange"}}
                    >
                        {item?.condition === "New" ? "New, sealed": "No box"}
                    </span>
                    {discount > 0 && <span className="discount-perc">{"-"}{discount * 100}{"%"}</span>}
                    <span className="bottom-section">
                        {discount > 0 &&
                            (<s>
                                <span className="discount-text">
                                    {original_cost} FCFA
                                </span>
                            </s>)}

                        <span className="item-cost">
                            {(original_cost - original_cost * discount).toLocaleString()} FCFA
                        </span>
                    </span>
                </span>
                <span className="more-bottom">
                    <span
                        className="more-button"
                        onClick={onClick}
                    >
                        <span className="more-text">View product</span>
                    </span>
                </span>
            </button>
        </div>
    )
}